import { FC } from "react";

import {
	EnhancedDropDownRHFWithLabel,
	EnhancedTextAreaFieldRHF,
	ITest,
	LabelPosition,
} from "@websential/cosmic-v20";

interface IEmployeeStubSetupFieldsPanel extends ITest {
	isAdminUser: any;
}
export const EmployeeStubSetupFieldsPanel: FC<
	IEmployeeStubSetupFieldsPanel
> = ({ isAdminUser }) => {
	return (
		<>
			<EnhancedDropDownRHFWithLabel
				selectName="stubLanguage"
				label="Stub Language"
				labelPosition={LabelPosition.Top}
				// required
				testId={`Stub-Language`}
				items={[
					{ label: "English", value: 100 },
					{ label: "French", value: 200 },
				]}
				selectedItem={100}
				labelColumns={4}
				fieldColumns={8}
				// onSelectionChangeHandler={onSelectionChangeHandler}
			/>
			<EnhancedDropDownRHFWithLabel
				selectName="emailStub"
				label="Email Stub"
				labelPosition={LabelPosition.Top}
				// required
				testId={`Email-Stub`}
				items={[
					{ label: "Yes", value: 200 },
					{ label: "No", value: 100 },
				]}
				selectedItem={100}
				labelColumns={4}
				fieldColumns={8}
				// onSelectionChangeHandler={onSelectionChangeHandler}
			/>
			<EnhancedDropDownRHFWithLabel
				selectName="printHourlyRateOnStub"
				label="Print hourly rate on stub"
				labelPosition={LabelPosition.Top}
				// required
				testId={`Print-hourly-rate-on-stub`}
				items={[
					{ label: "Yes", value: 200 },
					{ label: "No", value: 100 },
				]}
				selectedItem={100}
				labelColumns={4}
				fieldColumns={8}
				// onSelectionChangeHandler={onSelectionChangeHandler}
			/>
			<EnhancedTextAreaFieldRHF
				label="Stub Notes"
				id="stubNotes"
				testId={`Stub-Notes`}
				placeholder="Stub Notes"
				labelPosition={LabelPosition.Top}
				labelColumns={4}
				fieldColumns={8}
			/>
		</>
	);
};
